export enum Flags {
  isOfferApprovalRequired = "isOfferApprovalRequired",
  isPremiumEnabled = "isPremiumEnabled",
  isRegistrationDisabled = "isRegistrationDisabled",
}
